
import { defineComponent } from 'vue';
import LinkNavBar from "@/components/NavBar/LinkNavBar.vue";
export default defineComponent({
  name: 'NavBar',
  components: {
    LinkNavBar
  }
});
